<script setup lang="ts">
type SignatureProps = {
  totalBalance: number
  wireInstructions: string
  signaturePath: string
}

const props = defineProps<SignatureProps>()
const { t } = useI18n()

</script>

<template>
  <div class="car-invoice-v2__signature">
    <div class="car-invoice-v2__signature-left">
      <div class="total-balance">
        <span>{{ t('pdf.wireInstructions.totalCarsBalance') }}:</span> <FormatCurrencyColor :value="props.totalBalance" />
      </div>
      <div v-html="props.wireInstructions" />
    </div>
    <div class="car-invoice-v2__signature-right">
      <img
        :src="props.signaturePath"
        class="signature"
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.total-balance {
  margin-bottom: 15px;
}

.car-invoice-v2__signature {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #000;

  &-left {
    display: flex;
    flex-direction: column;

    .row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 5px;

      .value {
        font-weight: 700;
        margin-left: 5px;
      }
    }
  }

  &-right {
    .signature {
      width: 220px;
    }
  }
}
</style>
